var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"services__item",attrs:{"to":{
      name: 'service-single-external',
      params: { id: _vm.s.id },
      props: { remote: true },
    },"data-external":"true","data-url":_vm.s.title.rendered,"data-type":"citizen"}},[_c('div',{staticClass:"image",style:({ backgroundImage: 'url(' + _vm.s.acf.image + ')' })}),_c('div',{staticClass:"info"},[_c('div',{staticClass:"name",domProps:{"innerHTML":_vm._s(_vm.highlightTerms(_vm.s.title.rendered))}}),_c('div',{staticClass:"descr"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.highlightTerms(_vm.s.acf.service_descr))}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }